import apiTrainingGroups from '@/api/training-groups'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createTrainingGroupStart: '[create training groups] Create trainer start',
  createTrainingGroupSuccess: '[create training groups] Create trainer success',
  createTrainingGroupFailure: '[create training groups] Create trainer failure'
}

export const actionTypes = {
  createTrainingGroup: '[create training groups] Create training groups'
}

const mutations = {
  [mutationTypes.createTrainingGroupStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.createTrainingGroupSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createTrainingGroupFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createTrainingGroup](context, {trainingGroup}) {
    context.commit(mutationTypes.createTrainingGroupStart)
    return new Promise(resolve => {
      apiTrainingGroups
        .createTrainingGroups(trainingGroup)
        .then(response => {
          context.commit(mutationTypes.createTrainingGroupSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createTrainingGroupFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
